import { useNavigate } from "react-router-dom"
import { logoutDevice } from "../restApi/api"
import { decrypt, decryptdata } from "./crypto"
import { toast } from 'react-toastify';

const showToastError = (message) => {
  toast.error(message);
};
export const authorizationCheck= (navigate) => {
  let user=JSON.parse(decrypt(localStorage.getItem('profileDetails')))
    let data={
        "deviceId": decryptdata(localStorage.getItem('dId')),
        "isSelf": true,
        "isAllLogout": false,
        "userId": user?.id 
    }
         logoutDevice(data)
          .then(response => {
            return response.json()
          })
          .then(data => {
            let req= JSON.parse(decrypt(data))
              if(req.data.code==1){
                // var datasetString = JSON.stringify(null)
                // document.cookie = "dataset=" + encodeURIComponent(datasetString) + "; path=/";
                showToastError('Unauthorised token')
                localStorage.clear()
                navigate('/onboarding/login')
              }
          })
  }
  export const profileCheck= (navigate) => {
    localStorage.clear()
    navigate('/onboarding/login')
    // window.location.reload()
    }